import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { colors } from "../../theme/theme";
import ColorSelector from "./ColorSelector";
import { useHorizontalDragScroll } from "../../utils/useHorizontalDragScroll";
import { logUserAction } from "../../utils/analytics";

const SimilarProductCard = ({
  productData,
  noColor = false,
  oneLiner = false,
  showAll = false,
  verticalLayout = false,
}) => {
  const navigate = useNavigate();
  const innerScrollRef = useHorizontalDragScroll();

  const query = localStorage.getItem("query");

  return (
    <Box
      ref={innerScrollRef}
      className="flex overflow-x-auto"
      sx={{
        display: verticalLayout ? "grid" : "flex",
        gridTemplateColumns: verticalLayout ? "repeat(3, minmax(270px, 1fr))" : "none",
        flexDirection: verticalLayout ? "none" : "row",
        gap: 1.5,
        pb: 1.5,
        marginLeft: "-20px",
        pr: 1.5,
        pl: oneLiner ? 1 : 1.5,
        "&::-webkit-scrollbar": {
          display: "none",
        },
        ml: 0,
        pt: 0.5,
      }}
    >
      {productData.map(
        (product, index) =>
          (showAll || index !== 0) && (
            <Stack
              key={index}
              direction={"column"}
              sx={{
                ml: index === 0 ? 2 : 0,
              }}
            >
              <Card
                onClick={async () => {
                  await logUserAction({
                    action: "product_click",
                    data: {
                      product_id: product.product_id || null,
                      product_title: product.title || null,
                      brand: product.brand || null,
                      product_price:
                        product?.price?.discounted ||
                        product?.price?.original ||
                        null,
                      currency: product?.price?.currency || null,
                      product_image: product?.image_url || null,
                    },
                    timestamp: new Date().toISOString(),
                  });
                  navigate("/product", {
                    state: {
                      product: product,
                      similarProducts: productData,
                      searchQuery: query,
                    },
                  });
                }}
                sx={{
                  width: verticalLayout ? "100%" : (noColor ? "200px" : "220px"),
                  borderRadius: noColor ? "8px" : "12px",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  flexShrink: 0,
                  position: "relative",
                  overflow: "hidden",
                  backgroundColor: "#fff",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
                    transform: "translateY(-4px)",
                    borderColor: "rgba(0,0,0,0.1)",
                  },
                  "&:active": {
                    transform: "translateY(-2px)",
                  },
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <img
                    src={product.image_url}
                    onError={(e) =>
                      (e.target.src = require("../../assets/images/no_image.png"))
                    }
                    loading="lazy"
                    alt=""
                    style={{
                      objectFit: "contain",
                      height: noColor ? "380px" : "400px",
                      width: "100%",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Box>

                <CardContent
                  className="bg-white"
                  sx={{
                    p: noColor ? 2 : 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.75,
                    flexGrow: 1,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: noColor ? "14px" : "14px",
                      color: "#1a1a1a",
                      fontFamily: "Poppins-Medium",
                      fontWeight: "500",
                      lineHeight: 1.4,
                      display: "-webkit-box",
                      WebkitLineClamp: oneLiner ? 2 : 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      minHeight: oneLiner ? "auto" : "40px",
                    }}
                  >
                    {product?.title}
                  </Typography>

                  {!noColor && <ColorSelector small />}

                  <Box sx={{ mt: "auto", pt: 0.5 }}>
                    <Typography
                      sx={{
                        fontSize: noColor ? "15px" : "14px",
                        color: "#1a1a1a",
                        fontFamily: "Poppins-SemiBold",
                        fontWeight: "600",
                        letterSpacing: "-0.01em",
                      }}
                    >
                      {product?.price?.discounted ||
                        product?.price?.original ||
                        "N/A"}{" "}
                      <Typography
                        component="span"
                        sx={{
                          fontSize: noColor ? "13px" : "12px",
                          color: "#666",
                          fontFamily: "Poppins-Regular",
                          fontWeight: "400",
                        }}
                      >
                        {product?.price?.currency || ""}
                      </Typography>
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Stack>
          ),
      )}
    </Box>
  );
};

export default SimilarProductCard;
